import {Component, Input, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'rule-advance-condition',
  templateUrl: './rule-advance-condition.component.html',
  styleUrls: ['./rule-advance-condition.component.scss']
})
export class RuleAdvanceConditionComponent {

  @Input() item: any;

  constructor() {
  }

  isQBRUsed(value): boolean {
    return value !== null;
  }

  getSipHeaderKeyValues(key): any {
    const sipHeaders = _.groupBy(this.item.sipHeaders, (header) => {
      return header.name;
    });
    return sipHeaders[key];
  }

  getSipHeadersKeys(): any {
    const sipHeaders = _.groupBy(this.item.sipHeaders, (header) => {
      return header.name;
    });
    return _.keys(sipHeaders);
  }

  getTagsKeyValues(key): any {
    const tags = _.groupBy(this.item.tags, (t) => {
      return t.tag;
    });
    return tags[key];
  }

  getTagsKeys(): any {
    const tags = _.groupBy(this.item.tags, (t) => {
      return t.tag;
    });
    return _.keys(tags);
  }


}
